class PlayerPitcherMatchupModel {
    constructor (data) {
        const player = data?.people?.[0];
        const playerStats = player?.stats?.[0]?.splits?.[0];
        this.playerStats = playerStats;
        this.playerId = player.id;
        this.isDataLoaded = true;
        if (data) {
            this.hasData = true;
        }
    }
}

export default PlayerPitcherMatchupModel;
